@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.passengerwallet

import com.narbase.letsgo.web.dto.currency.CurrencyDto

data class ExtendedPassengerWalletDto(
    val wallet: PassengerWalletDto,
    val currency: CurrencyDto,
)
